import { render, staticRenderFns } from "./FormDeveloperAbout.vue?vue&type=template&id=bf82a72e&lang=pug&"
import script from "./FormDeveloperAbout.vue?vue&type=script&lang=js&"
export * from "./FormDeveloperAbout.vue?vue&type=script&lang=js&"
import style0 from "./FormDeveloperAbout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports